import Response from '../base/Response';

export default class PayloadResponse extends Response {

}
